import * as React from 'react';

import type { CredentialSchema, CredentialSecret } from '../../../../types';
import { ACCOUNT_PURPOSE_TEXT } from '../constants';

type Props = {
  schema: CredentialSchema;
  secret: CredentialSecret;
};

export const ColumnDetails: React.FunctionComponent<Props> = ({
  schema,
  secret,
}) => {
  const fields = schema.fields;

  return (
    <>
      <div className="d-flex">
        <div className="field-name">Account Type</div>
        <div data-cy="cred-type">
          {ACCOUNT_PURPOSE_TEXT[schema.purpose] ?? ''}
        </div>
      </div>
      <div className="d-flex mt-2">
        <div className="field-name">Account Name</div>
        <div className="field-value" data-cy="cred-name">
          <span>{secret.name}</span>
        </div>
      </div>
      {fields
        .filter(
          (field) => !field.sensitive && field.data_type !== 'fieldchoice',
        )
        .map((field) => (
          <div
            key={field.name}
            className="d-flex mt-2"
            data-cy={`field-${field.name}`}
          >
            <div className="field-name">{field.display_name}</div>
            <div className="field-value">
              <span>{secret.secrets[field.name]}</span>
            </div>
          </div>
        ))}
      {fields.length === 0 &&
        Object.keys(secret.secrets).length === 0 &&
        !!secret.tokens?.length && (
          <div className="d-flex mt-2" data-cy="field-token">
            <div className="field-name">Token</div>
            <div>{secret.tokens.join(',')}</div>
          </div>
        )}
    </>
  );
};
